import { withFormik } from 'formik'
/** @todo No @types for yup so have to require over import to skip TSC */
const Yup = require('yup')

/**
 *   Import
 *   - Components
 */
import { ForgotForm } from '../../../components/common/ForgotForm/ForgotForm'
import { Props } from '../../../components/pages/Forgot/Forgot'

/**
 *   Variables types
 */
export type Values = {
  email: string;
}

const withFormikComp = withFormik<Props, Values, Values>({
    displayName: 'ForgotForm',

    mapPropsToValues: (props) => {
        return {
            email: '',
        }
    },

    /**
     * Form validation fields settings
     * @type {[type]}
     */
    validationSchema: Yup.object().shape({
        email: Yup.string().email().required('Valid email address is required'),
    }),

    /**
     * Form Options
     * @type {Boolean}
     */
    validateOnChange: true,

    /**
     * handle the submit form action
     * @param  {object} values [Email address filled by user]
     * @param  {function} props: {forgot} [Forgot action trigger passed on global state]
     */
    handleSubmit: (values, { props: { forgot } }) => {
        forgot(values)
    },
})

export default withFormikComp(ForgotForm)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/ForgotForm/ForgotForm.tsx